import type { CollectionDto, CollectionModel } from '../../data-layer/collections/types';

export const toCollectionsModel = (collectionDto: CollectionDto): CollectionModel => ({
    id: collectionDto.id,
    url: `/profile/collections/${collectionDto.id}`,
    displayName: collectionDto.display_name,
    numberOfPosts: collectionDto.number_of_posts,
    previewItems: collectionDto.preview_items.map((content) => {
        if (content.type === 'image') {
            return {
                id: content.id,
                type: 'image',
                media: content.media,
            };
        }

        return {
            id: content.id,
            type: 'video',
            media: content.media.map((file) => ({
                url: file.url,
                width: file.width,
                height: file.height,
                firstFrameUrl: file.first_frame_url,
            })),
        };
    }),
    modifiable: collectionDto.modifiable,
    defaultCollection: collectionDto.default_collection,
});
